module.exports = __webpack_public_path__ + "media/components/src/assets/images/image_text/3-f644646e28b141381dd2631cd6f96375.jpg";